const e = {
  1: {
    component: "h1",
    fontSize: "48px"
  },
  2: {
    component: "h2",
    fontSize: "32px"
  },
  3: {
    component: "h3",
    fontSize: "24px"
  },
  4: {
    component: "h4",
    fontSize: "20px"
  },
  5: {
    component: "h5",
    fontSize: "18px"
  }
}, n = {
  1: {
    component: "h1",
    fontSize: "40px"
  }
}, o = {
  small: {
    lineHeight: "100%"
  },
  large: {
    lineHeight: "120%"
  }
}, t = {
  xsmall: {
    fontSize: "12px"
  },
  small: {
    fontSize: "14px"
  },
  medium: {
    fontSize: "16px"
  }
}, p = {
  small: {
    lineHeight: "120%"
  },
  large: {
    lineHeight: "140%"
  }
};
export {
  o as headingLineHeightMap,
  p as typographyBodyLineHeightMap,
  t as typographyBodySizeMap,
  e as typographyHeadingLevelMap,
  n as typographyHeadingLevelMobileAndTabletMap
};
